
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import FilterFields from "@/components/FilterFields";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Eye from "vue-material-design-icons/Eye.vue";

export default {
  name: "app-prospect",
  mixins: [SistemaMixin],
  components: {
    Eye,
    TrashCanIcon,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          sortable: true,
          slot: true,
          width: "5%",
        },
        {
          label: "Cliente",
          field: "cliente",
          type: "text",
          sortable: true,
          slot: true,
          width: "25%",
        },
        {
          label: "Usuário",
          field: "usuario",
          type: "text",
          sortable: true,
          slot: true,
          width: "25%",
        },
        {
          label: "Dt. Atendimento",
          field: "dataAtendimento",
          type: "text",
          sortable: true,
          slot: true,
          width: "15%",
        },
        {
          label: "Negócio",
          field: "negocio",
          type: "text",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
        },
      ],
      atendimentoSelecionado: null,
      urlGoogleMaps: null,
      urlAnexo1: null,
      urlAnexo2: null,
      urlAnexo3: null,
    };
  },
  methods: {
    selecionarAtendimento(atendimento) {
      this.atendimentoSelecionado = atendimento;
      this.urlGoogleMaps =
        "https://www.google.com.br/maps/@" +
        atendimento.latitude +
        "," +
        atendimento.longitude;
      this.urlAnexo1 = atendimento.anexo_1;
      this.urlAnexo2 = atendimento.anexo_2;
      this.urlAnexo3 = atendimento.anexo_3;
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o atendimento " + data.numero + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/prospect/delete", {
                id_prospect: data.id_prospect,
              });

              this.$refs.prospects.refresh();
              this.$toast.success("Atendimento excluído!");
            }
          });
      })
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
